import { MediaType } from '../../../constants/MediaType';
import { Orientations } from '../useVideoMaker/videoMaker.types';

interface IUrlData {
  square?: string;
  portrait?: string;
  landscape?: string;
}

export interface IVideoTemplate {
  type: string;
  thumbnailUrl: IUrlData;
  videoUrls: IUrlData;
  font: string;
  primaryColor: string;
  secondaryColor: string;
  themeId: string;
  trackId: string;
  customClosingText?: boolean;
  sources: { id: string; mediaType: MediaType; url: string }[];
  orientation?: Orientations;
}

export const VideoTemplates: IVideoTemplate[] = [
  {
    type: 'create-new',
    thumbnailUrl: {
      square:
        'https://static.wixstatic.com/media/680f60_eb2c1984fe35494e9a55302856de2c6a~mv2.png',
      portrait:
        'https://static.wixstatic.com/media/680f60_67e3c09124b44b4098997442d1cb677f~mv2.png',
      landscape:
        'https://static.wixstatic.com/media/680f60_564af95ad7dc4b2296cd0228a9c40a48~mv2.png',
    },
    videoUrls: {
      landscape:
        'https://video.wixstatic.com/video/ed4c78_439ef8d4327044f0992aecab75f89d40/1080p/mp4/file.mp4',
      portrait:
        'https://video.wixstatic.com/video/ed4c78_c91e633196f24c1186f6dc839bbf7d5e/1080p/mp4/file.mp4',
      square:
        'https://video.wixstatic.com/video/ed4c78_f947d02d6cec4cdf92a6e6126c65fe30/720p/mp4/file.mp4',
    },
    font: 'Raleway',
    primaryColor: '#2233d5',
    secondaryColor: '#fb6625',
    themeId: '174',
    trackId: '23376',
    customClosingText: true,
    sources: [
      {
        id: 'ed4c78_f58a7601329944ca88dd4d42b3959283',
        mediaType: MediaType.Video,
        url:
          'https://video.wixstatic.com/video/ed4c78_f58a7601329944ca88dd4d42b3959283/1080p/mp4/file.mp4',
      },
      {
        id: 'ed4c78_9478d31134144ea3a2666c451823b9a0~mv2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_9478d31134144ea3a2666c451823b9a0~mv2.jpg',
      },
      {
        id: 'ed4c78_1635646d65924751a7929333ebad2a25~mv2.png',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_1635646d65924751a7929333ebad2a25~mv2.png',
      },
      {
        id: 'ed4c78_79cdc13494e245899c35a9d8b351c560',
        mediaType: MediaType.Video,
        url:
          'https://video.wixstatic.com/video/ed4c78_79cdc13494e245899c35a9d8b351c560/1080p/mp4/file.mp4',
      },
    ],
  },
  {
    type: 'christmas',
    thumbnailUrl: {
      square:
        'https://static.wixstatic.com/media/b02fd4_b55a2fc98a49432dae62c2a833dee339~mv2.png',
      portrait:
        'https://static.wixstatic.com/media/ed4c78_594f7873df2e4ba8b2c6cd5de9d87afc~mv2.png',
      landscape:
        'https://static.wixstatic.com/media/b02fd4_a1bc2bd848404930a20d4538456c9ee9~mv2.png',
    },
    videoUrls: {
      landscape:
        'https://video.wixstatic.com/video/ed4c78_83c7b053628c4cc6ad391a2d71faee5a/1080p/mp4/file.mp4',
      portrait:
        'https://video.wixstatic.com/video/ed4c78_a18725589c5e4dbbaf22037dc22b40fb/1080p/mp4/file.mp4',
      square:
        'https://video.wixstatic.com/video/ed4c78_2103d4866a2a4ef0a0dc5b60539f2a87/720p/mp4/file.mp4',
    },
    font: 'FuturaPT',
    primaryColor: '#FF5951',
    secondaryColor: '#C21D0D',
    themeId: '149',
    trackId: '22934',
    customClosingText: true,
    sources: [
      {
        id: 'ed4c78_d7910089fdc84692b2199bc5eb3f69d2~mv2',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_d7910089fdc84692b2199bc5eb3f69d2~mv2.png',
      },
      {
        id: 'ed4c78_fa4598ae79d742e88b2cd16bd3eca9fb~mv2',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_fa4598ae79d742e88b2cd16bd3eca9fb~mv2.png',
      },
      {
        id: 'ed4c78_09bac7702ba944899aad4953a13f9470~mv2',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_09bac7702ba944899aad4953a13f9470~mv2.png',
      },
      {
        id: 'ed4c78_bf73a24160cd4615b2ac5f559918b9a4~mv2',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_bf73a24160cd4615b2ac5f559918b9a4~mv2.png',
      },
    ],
  },
  {
    type: 'easter',
    thumbnailUrl: {
      square:
        'https://static.wixstatic.com/media/ed4c78_e3dcdd9e398a435880075e18cba5a8e4~mv2.png',
      portrait:
        'https://static.wixstatic.com/media/ed4c78_b39c246ea0084c89bc11c678e3bad196~mv2.png',
      landscape:
        'https://static.wixstatic.com/media/ed4c78_b038acd3ac744b91817881c4a804f5cb~mv2.png',
    },
    videoUrls: {
      landscape:
        'https://video.wixstatic.com/video/ed4c78_8aaaeeaa05d24c7487cec1d0244af288/720p/mp4/file.mp4',
      portrait:
        'https://video.wixstatic.com/video/ed4c78_e309b705ac604e40b04cba0a5d71b266/720p/mp4/file.mp4',
      square:
        'https://video.wixstatic.com/video/ed4c78_2e54c12e735647fdb411a6d40bd6185d/720p/mp4/file.mp4',
    },
    font: 'ProximaNova',
    primaryColor: '',
    secondaryColor: '',
    themeId: '236',
    trackId: '23190',
    customClosingText: true,
    sources: [
      {
        id: 'ed4c78_90178de211c14fa68e83483371a556c4~mv2',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_90178de211c14fa68e83483371a556c4~mv2.png',
      },
      {
        id: 'ed4c78_3a2d497fcad14272829e857a34166ce4~mv',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_3a2d497fcad14272829e857a34166ce4~mv2.png',
      },
      {
        id: 'ed4c78_4ddf5665a11e4762a8e2fd9e0a6a09cb~mv2',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_4ddf5665a11e4762a8e2fd9e0a6a09cb~mv2.png',
      },
      {
        id: 'ed4c78_490873b2be5c479d93d0111fe58c7184~mv2',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_490873b2be5c479d93d0111fe58c7184~mv2.png',
      },
    ],
  },

  {
    type: 'promote-your-business',
    thumbnailUrl: {
      square:
        'https://static.wixstatic.com/media/ed4c78_fb6ca0153c274310b9c68c4176cd3077~mv2.png',
      portrait:
        'https://static.wixstatic.com/media/ed4c78_378fd5f418ab4400b251ee2a4c08ec1b~mv2.png',
      landscape:
        'https://static.wixstatic.com/media/ed4c78_735b4410f00342d694d592e6c22cd436~mv2.png',
    },
    videoUrls: {
      landscape:
        'https://video.wixstatic.com/video/ed4c78_09a9708ad82b4743811e128a162a91bc/1080p/mp4/file.mp4',
      portrait:
        'https://video.wixstatic.com/video/ed4c78_bb54cbfcf09949129f1d584aeda55bb1/1080p/mp4/file.mp4',
      square:
        'https://video.wixstatic.com/video/ed4c78_3d87a6f88c504aa6886913f84872c954/720p/mp4/file.mp4',
    },
    font: 'NotoSerif',
    primaryColor: '#FFFFFF',
    secondaryColor: '#D8ECF7',
    themeId: '196',
    trackId: '23231',
    sources: [
      {
        id: '81fd2f_f4fc4f4eeae44c1fa71abf729ee69b06~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_f4fc4f4eeae44c1fa71abf729ee69b06~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_a28d01c9c6654f2ba00115bed8538621~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_a28d01c9c6654f2ba00115bed8538621~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_7f85b8a4ec9e4600b9d20be67181f8a3~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_7f85b8a4ec9e4600b9d20be67181f8a3~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_89797ae9a06148a490c2855c527eec6b~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_89797ae9a06148a490c2855c527eec6b~mv2_d_3200_1800_s_2.jpg',
      },
    ],
  },
  {
    type: 'whats-new',
    thumbnailUrl: {
      square:
        'https://static.wixstatic.com/media/ed4c78_d26c1276a36342b697fff5adb1112629~mv2.png',
      portrait:
        'https://static.wixstatic.com/media/ed4c78_f70b7174cbb04d8db0d6759f2c420880~mv2.png',
      landscape:
        'https://static.wixstatic.com/media/ed4c78_e2e80d15dbe24f3e83cb2d30e3c8c6e1~mv2.png',
    },
    videoUrls: {
      landscape:
        'https://video.wixstatic.com/video/ed4c78_b6c295d55c7944868e556d7509afb33f/1080p/mp4/file.mp4',
      portrait:
        'https://video.wixstatic.com/video/ed4c78_8c2c83d16aa74a1287591d45d61c5933/1080p/mp4/file.mp4',
      square:
        'https://video.wixstatic.com/video/ed4c78_1cf30c2d2cc448e3b2e299dbbefe7403/720p/mp4/file.mp4',
    },
    font: 'Cervo',
    primaryColor: '#000000',
    secondaryColor: '#CEB8AB',
    themeId: '207',
    trackId: '23218',
    sources: [
      {
        id: '81fd2f_08cdb9ea35d341078bf9f2a67f09ad6e~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_08cdb9ea35d341078bf9f2a67f09ad6e~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_1dee09f7691a4cd29d1ef758087254c7~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_1dee09f7691a4cd29d1ef758087254c7~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_e7faf15ea73440c59834623a644438a3~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_e7faf15ea73440c59834623a644438a3~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_ec4409fe8cf345ceb0059a5de025b1fa~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_ec4409fe8cf345ceb0059a5de025b1fa~mv2_d_3200_1800_s_2.jpg',
      },
    ],
  },
  {
    type: 'announce-a-sale',
    thumbnailUrl: {
      square:
        'https://static.wixstatic.com/media/ed4c78_083f3bf2369a44e097f5c6f0cb7a56d3~mv2.png',
      portrait:
        'https://static.wixstatic.com/media/ed4c78_0d67a9df111443e8b1317422e7b3e876~mv2.png',
      landscape:
        'https://static.wixstatic.com/media/ed4c78_0e3479e0b9514efdb00a9f4dc15a7e99~mv2.png',
    },

    videoUrls: {
      landscape:
        'https://video.wixstatic.com/video/ed4c78_f48386e7469b4ac78b8edf138f834bef/1080p/mp4/file.mp4',
      portrait:
        'https://video.wixstatic.com/video/ed4c78_b1b8b270a4fa4ad0b02f89aa5c3619b8/1080p/mp4/file.mp4',
      square:
        'https://video.wixstatic.com/video/ed4c78_adecd30307ed40d48c3fa424456753fd/720p/mp4/file.mp4',
    },
    font: 'OpenSans',
    primaryColor: '#000000',
    secondaryColor: '#DB0000',
    themeId: '211',
    trackId: '23876',
    sources: [
      {
        id: '81fd2f_bf9ee72183cb4e189c16692fa2fdc54d~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_bf9ee72183cb4e189c16692fa2fdc54d~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_01be5d593a8648fabaaa4471fba657b0~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_01be5d593a8648fabaaa4471fba657b0~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_96570b63bfce44b2abcd606e532d6cf9~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_96570b63bfce44b2abcd606e532d6cf9~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_02d91be0b7034a948aa3ddafb0e19850~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_02d91be0b7034a948aa3ddafb0e19850~mv2_d_3200_1800_s_2.jpg',
      },
    ],
  },
  {
    type: 'share-an-exciting-update',
    thumbnailUrl: {
      portrait:
        'https://static.wixstatic.com/media/ed4c78_fb37fd46d1fd4119969804aa0953e952~mv2.png',
    },
    videoUrls: {
      portrait:
        'https://video.wixstatic.com/video/ed4c78_8c2c83d16aa74a1287591d45d61c5933/1080p/mp4/file.mp4',
    },
    font: 'Cervo',
    primaryColor: '#000000',
    secondaryColor: '#CEB8AB',
    themeId: '207',
    trackId: '23218',
    sources: [
      {
        id: '81fd2f_08cdb9ea35d341078bf9f2a67f09ad6e~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_08cdb9ea35d341078bf9f2a67f09ad6e~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_1dee09f7691a4cd29d1ef758087254c7~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_1dee09f7691a4cd29d1ef758087254c7~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_e7faf15ea73440c59834623a644438a3~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_e7faf15ea73440c59834623a644438a3~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: '81fd2f_ec4409fe8cf345ceb0059a5de025b1fa~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/81fd2f_ec4409fe8cf345ceb0059a5de025b1fa~mv2_d_3200_1800_s_2.jpg',
      },
    ],
  },
  {
    type: 'celebrate-a-milestone',
    thumbnailUrl: {
      square:
        'https://static.wixstatic.com/media/ed4c78_46ea70a8d4814fb6949e967bd93ce021~mv2.png',
      portrait:
        'https://static.wixstatic.com/media/ed4c78_22e834a913ec43acb2be2659de4e068e~mv2.png',
    },
    videoUrls: {
      square:
        'https://video.wixstatic.com/video/ed4c78_de863a7f3a5448e1b5eff0a722ed0f66/720p/mp4/file.mp4',
      portrait:
        'https://video.wixstatic.com/video/ed4c78_43a965c6908e4afcb32d744745cf8c96/1080p/mp4/file.mp4',
    },
    font: 'Rubik',
    primaryColor: '#F1F1F1',
    secondaryColor: '#103EF3',
    themeId: '212',
    trackId: '23376',
    sources: [
      {
        id: 'ed4c78_8dc588411bdf41bc90d739c0ac78bf22~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_8dc588411bdf41bc90d739c0ac78bf22~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: 'ed4c78_990f511780f74d05a9f9f58bba0cb626~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_990f511780f74d05a9f9f58bba0cb626~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: 'ed4c78_1f02a01ba94741a2adff57150e73be05~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_1f02a01ba94741a2adff57150e73be05~mv2_d_3200_1800_s_2.jpg',
      },
      {
        id: 'ed4c78_0836f35ce97b46c6a3c9e3d01590a986~mv2_d_3200_1800_s_2.jpg',
        mediaType: MediaType.Picture,
        url:
          'https://static.wixstatic.com/media/ed4c78_0836f35ce97b46c6a3c9e3d01590a986~mv2_d_3200_1800_s_2.jpg',
      },
    ],
  },
];
